import isNil from 'lodash/isNil';
import { MANAGERTYPE } from '@/constants/account';
import MsgUtil from '@/utils/message';
import mgrApi from '@/api/common/mgr';

export default {
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasAuth: false,
    };
  },
  watch: {
    objInfo: {
      immediate: true,
      handler(to) {
        if (!isNil(to)) {
          this.checkAuth();
        }
      },
    },
  },
  methods: {
    checkAuth() {
      const managerType = this.$store.getters.userInfo.managerType;
      if (managerType === MANAGERTYPE.ADMIN) {
        this.hasAuth = true;
      } else if (managerType === MANAGERTYPE.MANAGER) {
        mgrApi.checkObjAuth(this.objInfo.obj.objId).then((response) => {
          const result = response.data;
          if (result.success && result.data) {
            this.hasAuth = true;
          } else {
            this.hasAuth = false;
          }
        });
      } else {
        this.hasAuth = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/performance/hambuger-popup.js